import { api, unwrap, type APIResponse } from "./client";

// Mirrors app/routers/role.py schemas.
export interface Role {
  role_id: number;
  name: string;
  description: string | null;
  permissions: string[];
  user_count: number;
}

export interface Permission {
  permission_id: number;
  name: string;
  description: string | null;
}

export async function listRoles(): Promise<Role[]> {
  const resp = await api.get<APIResponse<Role[]>>("/roles/");
  return unwrap(resp.data);
}

export async function listPermissions(): Promise<Permission[]> {
  const resp = await api.get<APIResponse<Permission[]>>("/roles/permissions");
  return unwrap(resp.data);
}

export async function createRole(body: { name: string; description?: string }): Promise<number> {
  const resp = await api.post<APIResponse<{ role_id: number }>>("/roles/", body);
  return unwrap(resp.data).role_id;
}

export async function deleteRole(roleId: number): Promise<void> {
  await api.delete(`/roles/${roleId}`);
}

export async function setRolePermissions(roleId: number, permissions: string[]): Promise<void> {
  await api.put(`/roles/${roleId}/permissions`, { permissions });
}

export async function assignRole(userId: number, roleId: number): Promise<void> {
  await api.post("/roles/assign", { user_id: userId, role_id: roleId });
}

export async function unassignRole(userId: number, roleId: number): Promise<void> {
  await api.delete("/roles/assign", { data: { user_id: userId, role_id: roleId } });
}
